const billingStyle = {
  componentPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '20px',
  },
  section: {
    borderRadius: '8px',
    overflow: 'hidden',
    width: '100%',
  },
  sectionHeader: {
    paddingX: '20px',
    paddingY: '12px',
    borderBottom: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'grey.50',
  },
  sectionTitle: {
    fontWeight: 600,
  },
  sectionBody: {
    padding: '20px',
  },
  toggleControl: {
    width: '100%',
  },
  datePickerLabel: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '0.75rem',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
  },
}

export default billingStyle
